export function parseToggleToMarkdown(blocks) {
    if (blocks && blocks.text) {
        const formatted = blocks.text
            .replace(/<b>(.*?)<\/b>/g, '*$1*')
            .replace(/<i>(.*?)<\/i>/g, '_$1_')
            .replace(/<a href="(.*?)">(.*?)<\/a>/g, '[$2|$1|smart-link]');

        return `h2. ${formatted}`;
    } else {
        console.error("Invalid block structure:", blocks);
    }

    return '';
}
